import PropTypes from 'prop-types';
import React from 'react';
import { motion } from 'framer-motion';
// material
import { Box, Grid, Container, Typography, Slide, Stack, TextField, Button } from '@mui/material';
import { Icon } from '@iconify/react';
import { alpha, useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
// components
import arrowBackFilled from '@iconify/icons-eva/arrow-back-fill';
import Page from '../components/Page';
import RequestsServiceItem from '../components/_dashboard/requests/RequestsServiceItem';
import {
  RequestsSubDomain,
  RequestsHosting,
  RequestsRekomendasi,
  RequestsVideotron
} from '../components/_dashboard/requests';
import * as kategoriLayananService from '../services/kategorilayanan';
import * as myLayananService from '../services/mylayanan';
import isEligible from '../utils/roleEligibleGetter';
import AccessRequired from './AccessRequired';
import RequestsTTE from '../components/_dashboard/requests/RequestsTTE';
import RequestsAduan from '../components/_dashboard/requests/RequestsAduan';
import RequestsSPL from '../components/_dashboard/requests/RequestsSPLP';
import RequestsCloud from '../components/_dashboard/requests/RequestCloud';
import RequestsBackup from '../components/_dashboard/requests/RequestsBackup';
import RequestsVPN from '../components/_dashboard/requests/RequestsVPN';
import RequestsEmail from '../components/_dashboard/requests/RequestsEmail';
import RequestsWeb from '../components/_dashboard/requests/RequestsWeb';
// ----------------------------------------------------------------------

Requestspage.propTypes = {
  user: PropTypes.object.isRequired
};

export default function Requestspage({ user }) {
  const [kategoriLayanan, setKategoriLayanan] = React.useState({});
  const [rekomendasis, setRekomendasis] = React.useState([]);

  const getRekomendasis = async () => {
    if (_.isEmpty(user)) return;
    try {
      const idInstansi = user?.attributes?.id_instansi;

      const body = {
        id_instansi: idInstansi
      };
      const result = await myLayananService.getRekomendasis(body);

      const data = [];

      result.data.forEach((item) => {
        data.push({
          label: `${item?.attributes?.name} - ${item?.attributes?.createdAt} - ${item?.attributes?.status}`,
          id: item?.id,
          meta: item
        });
      });

      setRekomendasis(data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getKategoriLayanan = async () => {
    try {
      const result = await kategoriLayananService.getKategoriLayanan();
      setKategoriLayanan(result?.data?.meta?.categories);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getKategoriLayanan();
  }, []);

  React.useEffect(() => {
    getRekomendasis();
  }, [user]);

  const [menu, setMenu] = React.useState({ id: 'layanan', name: 'Layanan' });

  const selectMenu = (item) => {
    if (item) setMenu(item);
  };

  const theme = useTheme();
  return (
    <Page title="Dashboard | Layanan">
      {isEligible('page_requests') ? (
        <Container maxWidth="xl">
          <Box sx={{ pb: 5 }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              {menu.id !== 'layanan' && menu && (
                <Icon
                  cursor="pointer"
                  onClick={() => setMenu({ id: 'layanan', name: 'Layanan' })}
                  icon={arrowBackFilled}
                  width={32}
                  height={32}
                  style={{ color: theme.palette.primary.main }}
                />
              )}
              <Typography variant="h4">
                {menu.id === 'layanan' ? 'Daftar Layanan' : menu.name}
              </Typography>
            </Stack>
          </Box>
          {(menu.id === 'layanan' || !menu) && (
            <Grid container spacing={3}>
              {!_.isEmpty(kategoriLayanan) &&
                kategoriLayanan.map((item) => (
                  <Grid item xs={6} md={3} lg={3}>
                    <RequestsServiceItem item={item} handleClick={(item) => selectMenu(item)} />
                  </Grid>
                ))}
            </Grid>
          )}

          {menu.id === 'subdomain' && (
            <RequestsSubDomain user={user} setMenu={setMenu} rekomendasis={rekomendasis} />
          )}
          {menu.id === 'hosting' && (
            <RequestsHosting
              menu={menu}
              user={user}
              setMenu={setMenu}
              rekomendasis={rekomendasis}
            />
          )}
          {menu.id === 'rekomendasi' && <RequestsRekomendasi menu={menu} user={user} />}

          {menu.id === 'tte' && <RequestsTTE menu={menu} user={user} />}
          {menu.id === 'aduan' && <RequestsAduan menu={menu} user={user} />}
          {menu.id === 'videotron' && <RequestsVideotron menu={menu} user={user} />}
          {menu.id === 'splp' && <RequestsSPL user={user} />}
          {menu.id === 'cloud' && <RequestsCloud menu={menu} user={user} />}
          {menu.id === 'backup' && <RequestsBackup menu={menu} user={user} />}
          {menu.id === 'vpn' && <RequestsVPN menu={menu} user={user} />}
          {menu.id === 'email' && <RequestsEmail menu={menu} user={user} />}
          {menu.id === 'web' && <RequestsWeb menu={menu} user={user} />}
        </Container>
      ) : (
        <AccessRequired />
      )}
    </Page>
  );
}
